"use strict";var Hsva=function(){function i(i,t,s,n){this.h=i,this.s=t,this.v=s,this.a=n}return i}();exports.Hsva=Hsva;var Hsla=function(){function i(i,t,s,n){this.h=i,this.s=t,this.l=s,this.a=n}return i}();exports.Hsla=Hsla;var Rgba=function(){function i(i,t,s,n){this.r=i,this.g=t,this.b=s,this.a=n}return i}();exports.Rgba=Rgba;var SliderPosition=function(){function i(i,t,s,n){this.h=i,this.s=t,this.v=s,this.a=n}return i}();exports.SliderPosition=SliderPosition;var SliderDimension=function(){function i(i,t,s,n){this.h=i,this.s=t,this.v=s,this.a=n}return i}();exports.SliderDimension=SliderDimension;
//# sourceMappingURL=classes.js.map



/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2-color-picker/lib/classes.js
 ** module id = 30
 ** module chunks = 2
 **/